import { groupArray } from "@/utils"
import { beforeunloadResponse } from "@/apisParticipantPublic"

const generateResponseList = (list) => {
    const { create = [], update = [] } = groupArray(list, "status", {})
    return {
        createList: create,
        updateList: update,
    }
}

const bulkSaveResponseCloseWindow = (finalResponseAssessmentContent, participantDetail) => {
    const { participantId } = participantDetail
    const { projectId } = participantDetail.projects
    const { companyId } = participantDetail.projects
    const requestParticipantDetail = {
        participantId,
        projectId,
        companyId,
    }

    const { createList, updateList } = generateResponseList(finalResponseAssessmentContent)
    if (createList.length || updateList.length) {
        // do not call api if there is no new record created/updated
        beforeunloadResponse(createList, updateList, requestParticipantDetail)
    }
}

// eslint-disable-next-line import/prefer-default-export
export { bulkSaveResponseCloseWindow }
